<template>
  <div>
    <div class="five-top">
      <div class="item" v-for="item in customList" :key="item.id">
        <div class="item-top">
          <span class="desc">{{ item.desc }}</span>
          <span class="unit">{{ item.unit }}</span>
        </div>
        <div class="item-bottom">
          <img :src="item.img" />
          <span class="desc1">{{ item.desc1 }}</span>
        </div>
      </div>
    </div>
    <five-function></five-function>
    <article class="five-product">
      <div class="product-top">
        <h3>产品特性</h3>
        <span></span>
      </div>
      <span class="product-text"> 丰富的产品功能，增加用户体验感 </span>
      <div class="product-content clearfix">
        <div class="content" v-for="list in productList" :key="list.id">
          <div class="content-top">
            <img :src="list.img" />
          </div>
          <div class="content-center">
            <span class="desc">{{ list.desc }}</span>
          </div>
          <div class="content-bottom">
            <span class="desc1">{{ list.desc1 }}</span>
          </div>
        </div>
      </div>
    </article>
    <address class="five-security">
      <div class="security">
        <div class="security-top">
          <h3>安全保障</h3>
          <span></span>
        </div>
        <span class="security-text">
          实时互动，双向链接，企业与客户的联络者
        </span>
        <div class="security-content">
          <div class="content-top clearfix">
            <div class="left">
              <img src="../../static/images/fiveG/sbaq.png" />
            </div>
            <div class="right">
              <div class="right-top">
                <span class="right-nubmer">01</span>
                <span class="right-circle"></span>
                <span class="right-text">设备安全</span>
              </div>
              <div class="right-content">
                <h3 class="right-title">服务器部署在移动云</h3>
                <span class="right-content"
                  >移动云安全保障能力，定期进行巡检、漏扫等安全措施，按照中国移动集团要求进行相关安全运维工作</span
                >
                <h3 class="right-title">已通过中国移动安全监测</h3>
                <span class="right-content"
                  >已按照中国移动安全管理部门要求完成安全扫描、漏洞修复等工作</span
                >
              </div>
            </div>
          </div>
          <div class="content-bottom clearfix">
            <div class="left">
              <div class="right-top">
                <span class="right-nubmer">02</span>
                <span class="right-circle"></span>
                <span class="right-text">登录安全</span>
              </div>
              <div class="right-content">
                <h3 class="right-title">账户密码+验证码登录</h3>
                <span class="right-content"
                  >使用企业名称+密码+图形验证码登录</span
                >
                <h3 class="right-title">强口令密码</h3>
                <span class="right-content"
                  >系统随机生成8位登录密码，为大、小写英文、字符、数字组合。采用MD5加密方式保存</span
                >
                <h3 class="right-title">接口登录</h3>
                <span class="right-content">可通过http接口方式接入发送</span>
              </div>
            </div>
            <div class="right">
              <img src="../../static/images/fiveG/dlaq.png" />
            </div>
          </div>
        </div>
      </div>
    </address>
    <five-app></five-app>
    <article class="five-cases">
      <div class="cases-top">
        <h3>应用案例</h3>
        <span></span>
      </div>
      <span class="cases-text"> 案例示范， 为商家提供有效宣传方案 </span>
      <div class="cases-content">
        <div class="cases-back"></div>
        <div class="content-top clearfix">
          <div class="left">
            <img src="../../static/images/fiveG/tc1.png" />
            <img src="../../static/images/fiveG/tc2.png" />
          </div>
          <div class="right">
            <div class="right-top">
              <span class="right-nubmer">01</span>
              <span class="right-circle"></span>
              <span class="right-text">陶瓷博览会宣传</span>
            </div>
            <div class="right-content">
              <div class="content-top">
                <img src="../../static/images/fiveG/fskh.png" />
                <span class="right-title">
                  发送客户：中国共产党阳城县委员会宣传部
                </span>
              </div>
              <div class="content-bottom">
                <img src="../../static/images/fiveG/fsl.png" />
                <h5 class="right-title">
                  发送量：<span>22</span>
                  <span>W</span>
                  <span>条</span>
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div class="cases-back1"></div>
        <div class="content-bottom clearfix">
          <div class="left">
            <div class="right-top">
              <span class="right-nubmer">02</span>
              <span class="right-circle"></span>
              <span class="right-text">广西梦之岛集团会员活动宣传</span>
            </div>
            <div class="right-content">
              <div class="content-top">
                <img src="../../static/images/fiveG/fskh.png" />
                <span class="right-title"> 发送客户：广西梦之岛集团 </span>
              </div>
              <div class="content-bottom">
                <img src="../../static/images/fiveG/fsl.png" />
                <h5 class="right-title">
                  发送量：<span>15</span>
                  <span>W</span>
                  <span>条</span>
                </h5>
              </div>
            </div>
          </div>
          <div class="right">
            <img src="../../static/images/fiveG/gx1.png" />
            <img src="../../static/images/fiveG/gx2.png" />
          </div>
        </div>
      </div>
    </article>
    <address class="five-footer">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a>立即咨询</a>
    </address>
  </div>
</template>
<script>
import FiveFunction from "@/components/pc/FiveFunction";
import FiveApp from "@/components/pc/FiveApp";
export default {
  name: "fiveCenter",
  data() {
    return {
      customList: [
        {
          id: 0,
          img: require("../../static/images/fiveG/fsl.png"),
          desc: 0,
          unit: "W",
          desc1: "每日发送量",
        },
        {
          id: 1,
          img: require("../../static/images/fiveG/dxtd.png"),
          desc: 0,
          unit: "+",
          desc1: "短信通道",
        },
        {
          id: 2,
          img: require("../../static/images/fiveG/zj.png"),
          desc: 0,
          unit: "+",
          desc1: "每日增加用户",
        },
        {
          id: 3,
          img: require("../../static/images/fiveG/yh.png"),
          desc: 0,
          unit: "亿",
          desc1: "短信覆盖用户",
        },
        {
          id: 4,
          img: require("../../static/images/fiveG/Like.png"),
          desc: 0,
          unit: "+",
          desc1: "用户好评率",
        },
      ],
      productList: [
        {
          id: 0,
          img: require("../../static/images/fiveG/yhgxg.png"),
          desc: "用户刚需高",
          desc1: "击中用户日常所需，福利获取周期短，活动互动感增强，参与感上升",
        },
        {
          id: 1,
          img: require("../../static/images/fiveG/swrh.png"),
          desc: "三网融合",
          desc1: "三网合一专属通道，分布式集群构架服务请求毫秒级响应",
        },
        {
          id: 2,
          img: require("../../static/images/fiveG/dxxsdy.png"),
          desc: "短信形式多样",
          desc1: "文字短信、长短信、视频短信、图片短信多种形式结合，生动有趣",
        },
        {
          id: 3,
          img: require("../../static/images/fiveG/ddzhl.png"),
          desc: "订单转化率高",
          desc1: "彩信配套轻商城，轻松转化，提高转化率与订单额",
        },
        {
          id: 4,
          img: require("../../static/images/fiveG/ddlg.png"),
          desc: "订单率高",
          desc1:
            "拥有一手资源，自主开发的分发系统和资源配置系统，智能路由，高达99%的到达率",
        },
        {
          id: 5,
          img: require("../../static/images/fiveG/jsxq.png"),
          desc: "及时性强",
          desc1: "应用场景标准化配置，活动课随时上线；实时监控，精准营销",
        },
        {
          id: 6,
          img: require("../../static/images/fiveG/sycb.png"),
          desc: "使用成本低",
          desc1:
            "极具竞争力的价格，使用越多单价越低，高性价比，按需付费，无网络及硬件维护成本",
        },
        {
          id: 7,
          img: require("../../static/images/fiveG/wdan.png"),
          desc: "稳定安全性高",
          desc1:
            "黑名单+模板审核，主力通道+备份通道，规避突发风险，确保发送顺畅",
        },
        {
          id: 8,
          img: require("../../static/images/fiveG/czbj.png"),
          desc: "操作便捷快速",
          desc1: "短信平台支持快速上传已有通讯录，省去手工逐一单个录入",
        },
        {
          id: 9,
          img: require("../../static/images/fiveG/htfw.png"),
          desc: "后台服务支撑",
          desc1: "7*24小时无缝对接，技术，销售，培训，应用方案灵活多变",
        },
        {
          id: 10,
          img: require("../../static/images/fiveG/gnkz.png"),
          desc: "功能扩展支撑",
          desc1: "平台营销功能模板将保持持续增添，无需二次开发",
        },
        {
          id: 11,
          img: require("../../static/images/fiveG/zzfw.png"),
          desc: "增值服务",
          desc1: "拥有点爆朋友圈的推广实力，自配策划保姆式服务",
        },
      ],
    };
  },
  mounted() {
    this.ChangeData();
  },
  methods: {
    ChangeData: function () {
      let one_timer = setInterval(() => {
        this.customList[0].desc += 2;
        this.customList[1].desc += 2;
        if (this.customList[0].desc == 200) {
          clearInterval(one_timer);
        }
      }, 2000 / 50);
      let two_timer = setInterval(() => {
        this.customList[2].desc += 2;
        if (this.customList[2].desc == 2000) {
          clearInterval(two_timer);
        }
      }, 2000 / 500);
      let three_timer = setInterval(() => {
        this.customList[3].desc++;
        if (this.customList[3].desc == 8) {
          clearInterval(three_timer);
        }
      }, 2000 / 4);
      let four_timer = setInterval(() => {
        this.customList[4].desc++;
        if (this.customList[4].desc == 99) {
          clearInterval(four_timer);
        }
      }, 2000 / 50);
    },
  },
  components: {
    FiveFunction,
    FiveApp,
  },
};
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

* {
  letter-spacing: 0.5px;
}

div {
  color: #333333;
}

.five-top {
  width: 1400px;
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 30px;
  box-sizing: border-box;

  .item {
    width: 30%;
    margin-left: 110px;
  }

  .item:first-child {
    margin-left: 0;

    .unit {
      font-size: 36px;
    }
  }

  .item:nth-child(4) .unit {
    font-size: 30px;
    position: relative;
    top: -3px;
  }

  .item:last-child {
    margin-left: 0;
    margin-right: 4px;
    text-align: right;
  }

  .item-top {
    margin-left: 46px;
    padding-top: 34px;
    padding-bottom: 20px;
    letter-spacing: 3px;
    color: #FFC000;
  }

  .desc {
    display: inline-block;
    font-weight: bold;
    font-size: 48px;
  }

  .unit {
    display: inline-block;
    margin-left: -7px;
    font-size: 35px;
  }

  .desc1 {
    display: inline-block;
    margin-left: 12px;
    vertical-align: bottom;
    font-size: 16px;
  }
}

.five-product {
  width: 1400px;
  margin: 0 auto;
  margin-top: 80px;
  text-align: center;

  .product-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .product-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .product-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .product-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 20px;

    .content {
      width: 320px;
      height: 229px;
      float: left;
      margin-left: 40px;
      margin-top: 40px;
      border: 1px solid #F3F3F3;
      box-sizing: border-box;

      .content-top {
        margin-top: 22px;
      }

      .content-center {
        font-size: 20px;
        margin-top: 11px;
        font-weight: bold;
      }

      .content-bottom {
        margin: 23px auto;
        width: 90%;
        line-height: 30px;
      }
    }

    .content:hover {
      transform: scale(1.1, 1.1);
      box-shadow: 2px 2px 10px #E0E0E0;
    }

    .content:first-child, .content:nth-child(5), .content:nth-child(9) {
      margin-left: 0;
    }
  }
}

.five-security {
  width: 100%;
  padding: 80px 0;
  margin: 0 auto;
  margin-top: 80px;
  background-color: #F5F5F5;
  text-align: center;

  .security {
    width: 1400px;
    margin: 0 auto;
  }

  .security-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .security-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .security-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .security-content {
    width: 1400px;
    margin: 0 auto;
    margin-top: 60px;
    background-color: white;

    .content-top, .content-bottom {
      width: 100%;
    }

    .content-top .left {
      width: 50%;
      float: left;

      img {
        width: 100%;
      }
    }

    .content-top .right {
      width: 50%;
      float: right;
      text-align: left;
    }

    .right-top {
      display: flex;
      margin-top: 47px;
      margin-left: 40px;
      font-weight: bold;
      align-items: center;
    }

    .right-nubmer {
      font-size: 28px;
      color: #FFC526;
      z-index: 1;
    }

    .right-circle {
      width: 20px;
      height: 20px;
      display: block;
      margin-left: -13px;
      margin-top: -15px;
      content: '';
      border-radius: 50%;
      background: linear-gradient(to right top, transparent 30%, #FFC526);
    }

    .right-text {
      font-size: 20px;
      margin-left: 10px;
    }

    .right-content {
      margin-left: 40px;
      width: 88%;

      .right-title {
        font-size: 18px;
        margin-top: 41px;
        line-height: 28px;
        font-weight: bold;
        margin-bottom: 9px;
      }

      .right-content {
        margin: 0;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .content-bottom .left {
      width: 50%;
      float: left;
      text-align: left;
    }

    .content-bottom .right {
      width: 50%;
      float: right;

      img {
        width: 100%;
      }
    }
  }
}

.five-cases {
  width: 1400px;
  margin: 0 auto;
  height: 1110px;
  margin-top: 26px;
  text-align: center;
  box-sizing: border-box;

  .cases-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .cases-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .cases-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .cases-content {
    width: 1400px;
    height: 800px;
    margin: 0 auto;
    margin-top: 39px;
    background-color: white;
    position: absolute;

    .cases-back {
      width: 1300px;
      height: 260px;
      background-color: #F5F5F5;
      position: relative;
      z-index: 0;
      top: 119px;
    }

    .cases-back1 {
      width: 1300px;
      height: 260px;
      background-color: #F5F5F5;
      position: relative;
      z-index: 0;
      top: -270px;
      left: 100px;
    }

    .content-top {
      display: inline-block;
      width: 1400px;
      position: relative;
      top: -238px;
      left: 7.7%;
      z-index: 1;

      .left {
        display: inline-block;
        position: relative;
        width: 50%;
        left: -425px;

        img {
          margin-left: 75px;
        }
      }

      .right {
        display: inline-block;
        position: relative;
        top: -7px;

        .right-top {
          position: relative;
          left: -3px;
          top: -316px;
          font-weight: bold;
          align-items: center;

          .right-nubmer {
            font-size: 28px;
            color: #FFC526;
            z-index: 1;
          }

          .right-circle {
            position: relative;
            width: 20px;
            height: 20px;
            display: block;
            left: 704px;
            top: -32px;
            content: '';
            border-radius: 50%;
            background: linear-gradient(to right top, transparent 30%, #FFC526);
          }

          .right-text {
            position: relative;
            font-size: 20px;
            top: -50px;
            left: 106px;
          }
        }

        .right-content {
          position: relative;
          left: 79px;
          top: -80px;

          .content-top {
            position: relative;
            left: 70px;
            vertical-align: bottom;

            .right-title {
              font-size: 16px;
              font-weight: bold;
              position: relative;
              left: 7px;
              top: 6px;
            }
          }

          .content-bottom {
            position: relative;
            top: -202px;
            left: -85px;

            .right-title {
              font-size: 16px;
              font-weight: bold;
              position: absolute;
              left: 730px;
              top: -7px;

              span {
                color: #FFC000;
              }

              span:first-child {
                position: relative;
                top: 2px;
                font-size: 30px;
              }

              span:nth-child(2) {
                position: relative;
                left: -3px;
                top: 2px;
                font-size: 20px;
              }

              span:last-child {
                position: relative;
                left: -6px;
              }
            }
          }
        }
      }
    }

    .content-bottom {
      display: inline-block;
      width: 1400px;
      position: relative;
      top: -208px;
      left: 7.7%;
      z-index: 1;

      .left {
        display: inline-block;
        position: relative;
        top: 28px;
        left: -526px;

        .right-top {
          position: relative;
          left: -3px;
          top: -304px;
          font-weight: bold;
          align-items: center;

          .right-nubmer {
            font-size: 28px;
            color: #FFC526;
            z-index: 1;
          }

          .right-circle {
            position: relative;
            width: 20px;
            height: 20px;
            display: block;
            left: 704px;
            top: -32px;
            content: '';
            border-radius: 50%;
            background: linear-gradient(to right top, transparent 30%, #FFC526);
          }

          .right-text {
            position: relative;
            font-size: 20px;
            top: -50px;
            left: 167px;
          }
        }

        .right-content {
          position: relative;
          left: 22px;
          top: -68px;

          .content-top {
            position: relative;
            left: 69px;
            vertical-align: bottom;

            .right-title {
              font-size: 16px;
              font-weight: bold;
              position: relative;
              left: 7px;
              top: 6px;
            }
          }

          .content-bottom {
            position: relative;
            top: -202px;
            left: -28px;

            .right-title {
              font-size: 16px;
              font-weight: bold;
              position: absolute;
              left: 730px;
              top: -8px;

              span {
                position: relative;
                color: #FFC000;
              }

              span:first-child {
                top: 2px;
                font-size: 30px;
              }

              span:nth-child(2) {
                left: -3px;
                top: 2px;
                font-size: 20px;
              }

              span:last-child {
                left: -6px;
              }
            }
          }
        }
      }

      .right {
        display: inline-block;
        position: absolute;
        width: 50%;
        top: -421px;
        left: 478px;

        img {
          margin-left: 75px;
        }
      }
    }
  }
}

.five-footer {
  width: 100%;
  height: 160px;
  background: url('../../static/images/fiveG/bg(1).png');
  margin-top: 70px;
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/FiveCenter.vue